// extracted by mini-css-extract-plugin
export default {"pageContainer":"FortressMessengers_pageContainer__oPqqN"};